import { render, staticRenderFns } from "./Patients.vue?vue&type=template&id=e362ef0c"
import script from "./Patients.vue?vue&type=script&lang=js"
export * from "./Patients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports